import {useState} from "react";
import {DrawingType, ProjectSource, Status} from "../../../../../models/enums";
import {useDrawingSummaryPDF} from "../components/pdf/useDrawingSummaryPDF";
import FitTime from "../../../../../models/FitTime";
import {OnFailure, OnSuccess} from "../../../../../utils/CallbackUtils";
import Section from "../../../../../models/Section";
import {apiInstance} from "../../../../../api/api";

export function useSiteAttachmentExporter() {
	const [status, setStatus] = useState(Status.IDLE);
	const {createSummaryPDFFile} = useDrawingSummaryPDF();

	function exportToSite(
		siteId: number,
		projectSource: ProjectSource,
		projectNumber: number,
		drawingData: {versionId: string, drawingType: DrawingType}[],
		fitTimes: FitTime[],
		sections: Section[],
		onSuccess: OnSuccess,
		onFailure: OnFailure,
	) {
		setStatus(Status.LOADING);

		const sourceLabel = projectSource === ProjectSource.JOB ? "Job" : "Quote";

		const process = async () => {
			for (const item of drawingData) {
				const file = await createSummaryPDFFile(item.drawingType, item.versionId, fitTimes, sections);
				const base64 = await readFileAsBase64(file);
				const drawingName = findDrawingName(sections, item.versionId).replace(/ /g, "_");
				const filename = `Takeoffs_summary-${sourceLabel}_#${projectNumber}_${drawingName}.pdf`;
				await apiInstance.siteApi.uploadAttachment(siteId, filename, base64);
			}
		};

		process()
			.then(() => {
				onSuccess();
				setStatus(Status.SUCCESS);
			})
			.catch(error => {
				onFailure(error);
				setStatus(Status.ERROR);
			});
	}

	return {status, exportToSite};
}

function readFileAsBase64(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			const result = reader.result as string;
			resolve(result.split(',')[1]);
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}

function findDrawingName(sections: Section[], versionId: string): string {
	for (const section of sections) {
		for (const costCenter of section.costCenters) {
			for (const drawing of costCenter.drawings) {
				if (drawing.versions.some(v => v.id === versionId)) {
					return drawing.name;
				}
			}
		}
	}
	return "summary";
}
